export enum StudentStatus {
    Guest = 0,
    Register = 1,
    InitialRegistration = 2,
    Archive = -1,
    Remove = -10
}